import React from 'react'
import vihanroomnew from "../images/vihanroomnew.jpg";
import vihanroom from "../images/best deluxe room berhampore.jpg";
import room from "../images/vihan.jpg";
import roomvihanvilas from "../images/room 6 berhampore.jpg"
import roomdeluxe from "../images/room5.jpg";
import bath from "../images/bathroon_vihan.jpg";


function Deluxevihan() {
  return (
    <div>
        <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="3" aria-label="Slide 4"></button>

    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="4" aria-label="Slide 5"></button>

    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="5" aria-label="Slide 6"></button>


  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={vihanroomnew} className="d-block w-100" alt="vihanroomnew"/>
      
    </div>
    <div className="carousel-item">
      <img src={vihanroom} className="d-block w-100" alt="vihanroom"/>
      
    </div>
    <div className="carousel-item">
      <img src={room} className="d-block w-100" alt="berhamporehotelroom"/>
      
    </div>
    <div className="carousel-item">
      <img src={roomvihanvilas} className="d-block w-100" alt="roomvihanvilas"/>
      
    </div>
    <div className="carousel-item">
      <img src={roomdeluxe} className="d-block w-100" alt="vilasclubresort"/>
      
    </div>
    <div className="carousel-item">
      <img src={bath} className="d-block w-100" alt="vilasclubresort"/>
      
    </div>

  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Deluxevihan